export default __webpack_public_path__ + "static/media/troy_standard-gradient_1080p.a8f0b1c9.png";